import React, {useEffect, useState} from "react";
import BeforeLoading from "../components/before-loading";
import MainRouter from "./index";
import Page403 from "./403";
import associateServices from "../services";

const LocationProtectedRoute = () => {

    const [countryAllowed, setCountryAllowed] = useState(null)
    // Helper function to extract query parameters from the URL

    useEffect(() => {
        const domain = window.location.hostname

        associateServices.checkLocation({
            domain,
        }).then(res => {
            // setCountryAllowed(true);
            if (!res?.data?.allowed) {
                if (res?.data?.navigate) {
                    // Construct the redirect URL with query parameters
                    const currentPath = window.location.pathname;
                    const searchParams = new URLSearchParams(window.location.search);
                    // const redirectUrl = `https://${res?.data?.navigate}?${searchParams}`;
                    const redirectUrl = `https://${res?.data?.navigate}${currentPath}?${searchParams}`;

                    return window.location.href = redirectUrl;
                }
            }
            setCountryAllowed(res?.data?.allowed || false);
        })

    }, [])

    if (countryAllowed === null)
        return <BeforeLoading/>


    if (!countryAllowed)
        return <Page403/>


    return <MainRouter/>
}


export default React.memo(LocationProtectedRoute)
